import { buildUserSettingConfig } from "../utils/settings/userSettingsConfigBuilder";
import { SETTINGS_CATEGORY, UserSettingConfig } from "../types/settingsTypes";
import { mergeSettingsConfig } from "../utils/settings/settingsConfigMerger";
import { DEBUG_SETTINGS_ENABLED, debugClientSettings } from "./debugSettingsConfig";

const coreSharedClientSettings: Record<string, UserSettingConfig[]> = {
	[SETTINGS_CATEGORY.GENERAL]: [
		buildUserSettingConfig({
			key: 'defaultModel',
			label: 'Default Model',
			description: 'The default model to use for new chat sessions',
			category: SETTINGS_CATEGORY.GENERAL,
			controlType: 'select',
			optionsSource: 'backend',
			backendOptionsConfig: {
				endpoint: '/models',
				transformType: 'models',
				fallbackValue: 'auto', // Fallback when stored model is unavailable
			},
			requiresRestart: false,
			isClientConfig: true,
			showReset: true,
			editable: true,
		}),
		// buildUserSettingConfig({
		// 	key: 'theme',
		// 	label: 'Theme',
		// 	description: 'The theme to use for the application',
		// 	category: SETTINGS_CATEGORY.GENERAL,
		// 	controlType: 'switch',
		// 	optionA: { value: 'light', label: 'Light' },
		// 	optionB: { value: 'dark', label: 'Dark' },
		// 	default: 'dark',
		// 	isClientConfig: true,
		// 	showReset: true,
		// 	editable: true,
		// }),
	],
	[SETTINGS_CATEGORY.EXPORT]: [
		buildUserSettingConfig({
			key: 'export_options.format',
			label: 'Export Format',
			description: 'The format to export the chat in',
			category: SETTINGS_CATEGORY.EXPORT,
			controlType: 'select',
			optionsSource: 'static',
			options: [
				{ value: 'pdf', label: 'PDF' },
				{ value: 'docx', label: 'Word Document' },
				{ value: 'markdown', label: 'Markdown' },
				{ value: 'txt', label: 'Text' },
				{ value: 'magazine', label: 'Magazine (.mag)' },
			],
			isClientConfig: true,
			showReset: true,
			editable: true,
		}),
		// export_options.config.* (formatting options)
		buildUserSettingConfig({
			key: 'export_options.theme',
			label: 'Export Theme',
			description: 'The theme to export the chat in',
			category: SETTINGS_CATEGORY.EXPORT,
			controlType: 'switch',
			optionA: { value: 'dark', label: 'Dark' },
			optionB: { value: 'light', label: 'Light' },
			isClientConfig: true,
			showReset: true,
			editable: true,
        }),
		buildUserSettingConfig({
			key: 'export_options.config',
			label: 'Export Configuration',
			description: 'Configure what metadata to include in exported chats',
			category: SETTINGS_CATEGORY.EXPORT,
			layout: 'stacked',
			controlType: 'multiCheckbox',
			checkboxOptions: [
				{ key: 'includeCitations', label: 'Citations', default: true, group: 'Content', tooltip: 'Include any RAG citations referenced in responses' },
				{ key: 'includeReasoning', label: 'Reasoning', default: true, group: 'Content', tooltip: 'Include any model reasoning and thinking steps' },
				{ key: 'showModel', label: 'Model', default: true, group: 'Display', tooltip: 'Show which model generated each response' },
				{ key: 'showTitle', label: 'Title', default: true, group: 'Display', tooltip: 'Show the chat title at the top of the export' },
				{ key: 'showRoleHeader', label: 'Role', default: true, group: 'Display', tooltip: 'Show role labels (User, Assistant) before each message' },
				{ key: 'includeHeader', label: 'Header', default: true, group: 'Layout', tooltip: 'Include a header section with export metadata' },
				{ key: 'includeFooter', label: 'Footer', default: true, group: 'Layout', tooltip: 'Include a footer section at the end' },
				{ key: 'includeImages', label: 'Images', default: true, group: 'Images', tooltip: 'Embeds any images found in the chat' },
			],
			isClientConfig: true,
			showReset: true,
			editable: true,
		}),
	],
};

// Const-gated include: when DEBUG_SETTINGS_ENABLED is false, bundlers tree-shake
// the debug config out of production builds. Flip the flag in debugSettingsConfig.ts
// and rebuild to surface a "Debug" tab exercising every input type.
export const sharedClientSettings: Record<string, UserSettingConfig[]> = DEBUG_SETTINGS_ENABLED
	? mergeSettingsConfig(coreSharedClientSettings, debugClientSettings)
	: coreSharedClientSettings;
